<template>
  <div v-if="showComponent">
    <vs-card class="mt-5">
      <div slot="header">
        <h3>Dados do Veículo do Terceiro</h3>
      </div>

      <div class="vx-row mt-4">
        <!-- Placa -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="Placa"
            name="Placa"
            v-model="formDadosVeiculoTerceiro.placa"
            v-mask="'AAA-#XX#'"
          />
        </div>

        <!-- Renavam -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="Renavam"
            name="Renavam"
            v-model="formDadosVeiculoTerceiro.renavam"
            v-mask="'##########-#'"
          />
        </div>

        <!-- Chassi -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="Chassi"
            name="Chassi"
            v-model="formDadosVeiculoTerceiro.chassi"
            v-mask="'XXXXXXXXXXXXXXXXX'"
          />
        </div>

        <!-- Número do Motor -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="Número do Motor"
            name="Número do Motor"
            v-model="formDadosVeiculoTerceiro.numeroMotor"
            v-mask="'XXXXXXXXXXXXXXX'"
          />
        </div>
      </div>

      <div class="vx-row mt-4">
        <!-- Tipo -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for="" class="vs-select--label">Tipo</label>
          <v-select
            class="selectStyle"
            :options="listTiposVeiculo"
            name="Tipo"
            id="Tipo"
            v-model="formDadosVeiculoTerceiro.tipoVeiculo"
            label="label"
            @input="getListMarcasPorTipo(formDadosVeiculoTerceiro)"
            :reduce="(item) => item.id"
          ></v-select>
        </div>

        <!-- Marca -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for="" class="vs-select--label">Marca </label>
          <v-select
            class="selectStyle"
            :options="listMarcas"
            name="Marca"
            id="Marca"
            v-model="formDadosVeiculoTerceiro.idMarca"
            label="label"
            @input="getListAnosModeloPorMarca(formDadosVeiculoTerceiro)"
            @option:selected="selectMarca($event)"
            :disabled="!habilitaSelecionaMarca"
            :reduce="(item) => item.id"
          ></v-select>
        </div>

        <!-- Ano do Modelo -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for="" class="vs-select--label">Ano do Modelo</label>
          <v-select
            class="selectStyle"
            :options="listAnosModelo"
            name="Ano do Modelo"
            id="Ano do Modelo"
            v-model="formDadosVeiculoTerceiro.anoModelo"
            label="label"
            @input="
              getListModelosPorAnoModelo(formDadosVeiculoTerceiro),
                getListAnosFabricacao(formDadosVeiculoTerceiro)
            "
            :disabled="!habilitaSelecionaAnoModelo"
            :reduce="(item) => item.id"
          ></v-select>
        </div>

        <!-- Modelo -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for="" class="vs-select--label">Modelo</label>
          <v-select
            class="selectStyle"
            :options="listModelos"
            name="Modelo"
            id="Modelo"
            v-model="formDadosVeiculoTerceiro.idModelo"
            label="label"
            @input="getValorFipe()"
            @option:selected="selectModelo($event)"
            :disabled="!habilitaSelecionaModelo"
            :reduce="(item) => item.id"
          ></v-select>
        </div>

        <!-- Ano de Fabricação -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for="" class="vs-select--label">Ano de Fabricação</label>
          <v-select
            class="selectStyle"
            :options="listAnosFabricacao"
            name="Ano de Fabricação"
            id="Ano de Fabricação"
            v-model="formDadosVeiculoTerceiro.anoFabricacao"
            :disabled="!habilitaSelecionaAnoFabricacao"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mt-4">
        <!-- Combustível -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for="" class="vs-select--label">Combustível</label>
          <v-select
            class="selectStyle"
            :options="listCombustiveis"
            name="Combustível"
            id="Combustível"
            v-model="formDadosVeiculoTerceiro.idCombustivel"
            label="label"
            :reduce="(item) => item.id"
          ></v-select>
        </div>

        <!-- Cor -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for="" class="vs-select--label">Cor</label>
          <v-select
            class="selectStyle"
            :options="listCores"
            name="Cor"
            id="Cor"
            v-model="formDadosVeiculoTerceiro.idCor"
            label="label"
            :reduce="(item) => item.id"
          ></v-select>
        </div>

        <!-- KM -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <vs-input
            type="number"
            class="w-full"
            label="KM"
            name="KM"
            v-model="formDadosVeiculoTerceiro.km"
          />
        </div>

        <!-- Categoria -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <vs-input
            class="w-full"
            label="Categoria"
            name="Categoria"
            v-model="formDadosVeiculoTerceiro.categoria"
            v-mask="'XXXXXXXXXX'"
          />
        </div>

        <!-- Cilindrada -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <vs-input
            type="number"
            class="w-full"
            label="Cilindrada"
            name="Cilindrada"
            v-model="formDadosVeiculoTerceiro.cilindrada"
            :disabled="!habilitaCilindrada"
          />
        </div>
      </div>

      <div class="vx-row mt-4">
        <!-- Alienado -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for class="vs-input--label">Alienado</label>
          <vs-switch
            v-model="formDadosVeiculoTerceiro.alienado"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Código FIPE  -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <vs-input
            class="w-full"
            label="Código FIPE"
            name="Código FIPE"
            v-model="formDadosVeiculoTerceiro.codigoFipe"
            v-mask="'######-#'"
            disabled
          />
        </div>

        <!-- Valor FIPE  -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label for class="vs-input--label">Valor FIPE</label>
          <money
            class="w-full vs-inputx vs-input--input moneyStyle"
            v-model="formDadosVeiculoTerceiro.valorFipe"
            name="Valor FIPE"
            v-bind="moneyConfig"
            disabled
          />
        </div>
      </div>
    </vs-card>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import { Money } from 'v-money';

import notify from './../../../../../utils/notify';
import serviceEventos from './../../shared/service';

export default {
  props: ['formData'],
  components: {
    vSelect,
    Money,
  },
  watch: {
    'formDadosVeiculoTerceiro.tipoVeiculo'(newTipoVeiculo) {
      this.habilitaSelecionaMarca = newTipoVeiculo !== null;

      if (newTipoVeiculo && newTipoVeiculo == 2) {
        this.habilitaCilindrada = true;
      }

      if (this.loadingData) {
        return;
      }

      this.formDadosVeiculoTerceiro.idMarca = null;
    },
    'formDadosVeiculoTerceiro.idMarca'(newMarca) {
      this.habilitaSelecionaAnoModelo = newMarca !== null;

      if (this.loadingData) {
        return;
      }

      this.formDadosVeiculoTerceiro.anoModelo = null;
    },
    'formDadosVeiculoTerceiro.anoModelo'(newAnoModelo) {
      this.habilitaSelecionaModelo = newAnoModelo !== null;

      if (this.loadingData) {
        return;
      }

      this.formDadosVeiculoTerceiro.idModelo = null;
      this.formDadosVeiculoTerceiro.anoFabricacao = null;
    },
    'formDadosVeiculoTerceiro.idModelo'(newModelo) {
      this.habilitaSelecionaAnoFabricacao = newModelo !== null;
      if (newModelo === null) {
        this.formDadosVeiculoTerceiro.codigoFipe = null;
        this.formDadosVeiculoTerceiro.valorFipe = 0;
      }
    },
    async formData(value) {
      if (!value.dadosVeiculoTerceiro) {
        this.showComponent = false;
        console.error(
          'ERRO NO CONTRATO DO OBJETO - DADOS VEICULO TERCEIRO FORM',
        );
        return;
      }

      await this.loadData(value.dadosVeiculoTerceiro);

      this.formDadosVeiculoTerceiro = Object.assign(
        this.formDadosVeiculoTerceiro,
        value.dadosVeiculoTerceiro,
      );

      this.$nextTick(() => {
        this.loadingData = false;
      });

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.dadosVeiculoTerceiro = this.formDadosVeiculoTerceiro;
    },
  },
  data() {
    return {
      showComponent: true,
      loadingData: false,
      formDadosVeiculoTerceiro: {
        placa: null,
        tipoVeiculo: null,
        idModelo: null,
        veiculoModelo: null,
        idMarca: null,
        veiculoMarca: null,
        categoria: null,
        anoFabricacao: null,
        anoModelo: null,
        codigoFipe: null,
        valorFipe: 0,
        idCombustivel: null,
        idCor: null,
        renavam: null,
        chassi: null,
        numeroMotor: null,
        km: null,
        cilindrada: null,
        alienado: false,
      },
      listTiposVeiculo: [],
      listModelos: [],
      listMarcas: [],
      listAnosFabricacao: [],
      listAnosModelo: [],
      listCombustiveis: [],
      listCores: [],

      // Habilita/desabilita os selects
      habilitaSelecionaMarca: false,
      habilitaSelecionaAnoModelo: false,
      habilitaSelecionaModelo: false,
      habilitaSelecionaAnoFabricacao: false,
      habilitaCilindrada: false,

      //Configuração de componente
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$',
        suffix: '',
        precision: 2,
      },
    };
  },
  methods: {
    async getListTiposVeiculo() {
      try {
        this.$vs.loading();
        this.listTiposVeiculo = await serviceEventos.getListDominio(
          'domTipoFipe',
          'nomeTipo',
          'idTipoFipe',
        );
        this.$vs.loading.close();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    async getListMarcasPorTipo(value, showLoading = true) {
      const { tipoVeiculo } = value;

      if (tipoVeiculo == null) {
        return;
      }

      try {
        if (showLoading) {
          this.$vs.loading();
        }

        this.listMarcas = await serviceEventos.getListMarcasPorTipo(
          tipoVeiculo,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        if (showLoading) {
          this.$vs.loading.close();
        }
      }
    },
    async getListAnosModeloPorMarca(value, showLoading = true) {
      const { tipoVeiculo, idMarca } = value;

      if (!tipoVeiculo || !idMarca) {
        return;
      }

      try {
        if (showLoading) {
          this.$vs.loading();
        }

        const objSend = {
          idTipoVeiculo: tipoVeiculo,
          idMarca,
        };

        const resultAnosModeloAndModelos =
          await serviceEventos.getListModelosAndAnosModeloPorMarca(objSend);

        this.listAnosModelo = resultAnosModeloAndModelos.listAnosModelo;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        if (showLoading) {
          this.$vs.loading.close();
        }
      }
    },
    async getListModelosPorAnoModelo(value, showLoading = true) {
      const { tipoVeiculo, idMarca, anoModelo } = value;

      if (!tipoVeiculo || !idMarca || !anoModelo) {
        return;
      }

      try {
        if (showLoading) {
          this.$vs.loading();
        }

        const objSend = {
          idTipoVeiculo: tipoVeiculo,
          idMarca,
          ano: anoModelo,
        };

        this.listModelos = await serviceEventos.getListModelosPorAnoModelo(
          objSend,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        if (showLoading) {
          this.$vs.loading.close();
        }
      }
    },
    async getListAnosFabricacao(value, showLoading = true) {
      const { anoModelo } = value;

      if (!anoModelo) {
        return;
      }

      try {
        if (showLoading) {
          this.$vs.loading();
        }

        this.listAnosFabricacao = await serviceEventos.getListAnosFabricacao(
          anoModelo,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        if (showLoading) {
          this.$vs.loading.close();
        }
      }
    },
    async getListCoresAndCombustivel() {
      try {
        const result = await serviceEventos.getListCoresAndCombustiveis();
        this.listCombustiveis = result.listCombustiveis;
        this.listCores = result.listCores;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    async getValorFipe() {
      const { tipoVeiculo, idMarca, idModelo, anoModelo } =
        this.formDadosVeiculoTerceiro;

      if (!tipoVeiculo || !idMarca || !idModelo || !anoModelo) {
        return;
      }

      try {
        this.$vs.loading();

        const objSend = {
          codigoTipoVeiculo: tipoVeiculo,
          codigoMarca: idMarca,
          codigoModelo: idModelo,
          ano: anoModelo,
          anoModelo: anoModelo.split('-')[0],
          codigoTipoCombustivel: anoModelo.split('-')[1],
        };

        const result = await serviceEventos.getValorFipe(objSend);

        if (result) {
          this.formDadosVeiculoTerceiro.valorFipe = result.data.preco;
          this.formDadosVeiculoTerceiro.codigoFipe = result.data.fipe_codigo;
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    selectMarca(value) {
      this.formDadosVeiculoTerceiro.veiculoMarca = value.label;
    },
    selectModelo(value) {
      this.formDadosVeiculoTerceiro.veiculoModelo = value.label;
    },
    async loadData(value) {
      try {
        this.loadingData = true;
        this.$vs.loading();

        await this.getListMarcasPorTipo(value, false);
        await this.getListAnosModeloPorMarca(value, false);
        await this.getListModelosPorAnoModelo(value, false);
        await this.getListAnosFabricacao(value, false);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  mounted() {
    if (!this.formData.dadosVeiculoTerceiro) {
      console.error('ERRO NO CONTRATO DO OBJETO - DADOS GERAIS FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.dadosVeiculoTerceiro = this.formDadosVeiculoTerceiro;

    this.getListTiposVeiculo();
    this.getListCoresAndCombustivel();
  },
};
</script>

<style scoped>
.moneyStyle {
  font-size: 1rem !important;
  padding: 0.7rem !important;
}

.selectStyle {
  font-size: 1rem !important;
}
</style>
